import { jsxs as s, jsx as r } from "react/jsx-runtime";
import "react";
import { slugify as n } from "../../utils/helpers.js";
import { AnchorTag as h } from "../AnchorTag/AnchorTag.js";
import '../../assets/NavList.css';const i = {
  "nav-list": "_nav-list_37is6_1",
  "nav-list__item": "_nav-list__item_37is6_7"
};
function c({ title: t = "", links: l = [], classname: e = "", useNavWrapper: _ = !1 }) {
  const m = n(t);
  if (_) return /* @__PURE__ */ s("nav", { "aria-labelledby": t !== "" ? m : null, className: e, children: [
    t !== "" && /* @__PURE__ */ r("h2", { id: t !== "" ? m : null, className: "h4", children: t }),
    /* @__PURE__ */ r("ul", { className: `${e}__nav-list ${i["nav-list"]}`, children: l.map((a) => /* @__PURE__ */ r("li", { className: `${e}__nav-item ${i["nav-list__item"]}`, children: /* @__PURE__ */ r(
      h,
      {
        label: a.label,
        href: a.href,
        type: a.type,
        classname: `${e}__nav-link`,
        image: a != null && a.image ? a.image : null
      }
    ) }, `${e}-${Math.round(Math.random() * 1e7)}`)) })
  ] });
  if (!_) return /* @__PURE__ */ s("div", { className: e, children: [
    t !== "" && /* @__PURE__ */ r("h2", { className: "h4", children: t }),
    /* @__PURE__ */ r("ul", { className: [`${e}__nav-list`, i["nav-list"]].join(" "), children: l.map((a) => /* @__PURE__ */ r("li", { className: [`${e}__nav-item`, i["nav-list__item"]].join(" "), children: /* @__PURE__ */ r(
      h,
      {
        label: a.label,
        href: a.href,
        type: a.type,
        classname: `${e}__nav-link`,
        image: a != null && a.image ? a.image : null
      }
    ) }, `${e}-${Math.round(Math.random() * 1e7)}`)) })
  ] });
}
export {
  c as NavList,
  c as default
};
